/* eslint-disable @next/next/no-html-link-for-pages */
import styles from "../../styles/Home.module.css";
import {
  Box,
  Button,
  Center,
  SimpleGrid,
  Heading,
  Flex,
  Spacer,
  Square,
  Badge,
} from "@chakra-ui/react";
import Link from "next/link";
import React, { useState, useEffect } from "react";
import { Typeahead, withAsync } from "react-bootstrap-typeahead";
import { useRouter } from "next/router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { GetCookie } from "../../provider/common";
import { authLogoutEnglish } from "../../provider/auth";
import { useRecoilState } from "recoil";
import { estimateCntState } from "../../atoms/state";
import { useQuoteCnt } from "../../context/QuoteContext";
import { GetCartCnt, GetQuoteCnt } from "../../pages/api/cart";
import { getEstimateDataCnt } from "../../pages/api/estimate";

import { faCheck } from "@fortawesome/free-solid-svg-icons";
const axios = require("axios").default;

export default function Header(props) {
  const router = useRouter();
  const { keyword } = router.query; //미리 할당을 해줘야 처리됨

  const [inputKeyword, setInputKeyword] = useState(keyword);
  const [isLogin, setIsLogin] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [cartBadge, setCartBadge] = useState("red");
  const [estimateCnt, setEstimateCnt] = useRecoilState(estimateCntState);
  const [marketPlace, setMarketPlace] = useState("");
  const [sellerPageState, setSellePageStage] = useState("");
  const [reload, setReload] = useState("");

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [totalCount, setTotalCount] = useState("");
  const [data, setData] = useState("");
  const [category, setCategory] = useState("18");
  const [sequence, setSequence] = useState("new");
  const [byName, setByName] = useState("it_time");
  const [bySort, setBySort] = useState("DESC");

  const [search, setSearch] = useState("");
  const [industry, setIndustry] = useState("");
  const [selectedManufacturer, setSelectedManufacturer] = useState(null);
  const [openMode, setOpenMode] = useState("close");
  const quoteCnt = useQuoteCnt();
  const [headerLangVisible, setHeaderLangVisible] = useState(false);

  useEffect(() => {
    isLoginCheck();
    showCnt();

    // 현재 판매자 페이지 상태값을 따로 저장한다.
    changeSellerPageState();

    if (router.pathname === "/marketplace/market") {
      setMarketPlace("marketPlace");
    }

    if (router.pathname === "/") {
      setReload("start");
    }
  }, []);

  const changeSellerPageState = async () => {
    const approvedApi = process.env.PANDA_API_URL + "/api/auth/sellerDecode";
    const token = await GetCookie("token");
    const approvedRes = await axios.post(
      approvedApi,
      {
        token: token,
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );

    setSellePageStage(approvedRes.data.data);
  };

  async function isLoginCheck() {
    const isLogin = await GetCookie("isLogin");
    setIsLogin(Number(isLogin));
  }

  const showCnt = async () => {
    const estimateCnt = await getEstimateDataCnt();
    setEstimateCnt(estimateCnt);
  };

  // 로그아웃 기능
  const _handleLogout = async () => {
    await authLogoutEnglish();
  };

  const searchKeyword = (e) => {
    setPage(1);
    if (!search) {
      alert("Enter your search keyword.");
      return;
    }
    router.push(`/en?keyword=${encodeURIComponent(search)}`);
  };
  // 검색어 저장
  const saveKeyword = (e) => {
    setSearch(e.target.value);
  };

  const OnEnter = async (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      await searchKeyword();
    }
  };

  const pathname = router.asPath;

  const openModal = async () => {
    setOpenMode("open");
  };

  const closeModal = async () => {
    setOpenMode("close");
  };
  // EN -> KR 변경시
  const transferLanguage = async () => {
    if (pathname === "/en") {
      window.location.href = "/marketplace/market";
    } else if (pathname === "/en/seller/event") {
      window.location.href = "/seller/event";
    } else if (pathname === "/en/board/home?status=Terms") {
      window.location.href = "/board/home?status=privacy";
    } else if (pathname === "/en/board/home?status=Privacy") {
      window.location.href = "/board/home?status=terms";
    } else if (pathname === "/en/mypage/home?path=Orders") {
      window.location.href = "/mypage/home?path=order";
    } else if (pathname === "/en/mypage/home?path=My%20Account") {
      window.location.href = "/mypage/home?path=info";
    } else if (pathname === "/en/mypage/home?path=Address") {
      window.location.href = "/mypage/home?path=address";
    } else if (pathname === "/en/cart/view") {
      window.location.href = "/cart/view";
    } else if (pathname === "/en/order/view") {
      window.location.href = "/order/view";
    } else if (pathname === "/en/market/cart") {
      window.location.href = "/marketplace/cart";
    } else if (pathname === "/en/auth/login") {
      window.location.href = `/auth/login`;
    } else if (pathname === "/en/auth/req_password") {
      window.location.href = `/auth/req_password`;
    } else if (pathname === "/en/auth/register") {
      window.location.href = `/auth/register`;
    } else if (pathname === "/en/estimate/lists") {
      window.location.href = `/estimate/quote_lists`;
    } else if (pathname === "/en/estimate/request?type=manual") {
      window.location.href = `/estimate/request?type=manual`;
    } else {
      window.location.href = "/";
    }
  };

  return (
    <>
      <Box
        className="header header_en"
        borderTop="1px"
        borderBottom="1px"
        borderColor="#ededed"
      >
        <Box className="top-bar">
          <Box
            className="top-bar_box"
            variant="ghost"
            size="md"
            fontSize={14}
            p="0"
          >
            Easy RFQ & Fast Quoting Service
          </Box>
          {isLogin === 1 ? (
            <Box width="fit-content" className="flex-between">
              <Box
                width="fit-content"
                className="top-bar_transfer_lang"
                mr="15px"
                onMouseEnter={() => setHeaderLangVisible(true)}
                onMouseLeave={() => setHeaderLangVisible(false)}
              >
                <Box>
                  <Box className="top-bar_box top-bar-en">
                    <i className="xi-globus" style={{ marginRight: "5px" }}></i>
                    EN
                  </Box>
                  {headerLangVisible && (
                    <ul>
                      <li
                        onClick={() => {
                          setHeaderLangVisible(false);
                        }}
                      >
                        <b>EN</b>
                        <em></em>
                        <span>English</span>
                        <FontAwesomeIcon icon={faCheck} />
                      </li>
                      <li onClick={transferLanguage}>
                        <b>KO</b>
                        <em></em>
                        <span>한국어</span>
                        <FontAwesomeIcon icon={faCheck} />
                      </li>
                    </ul>
                  )}
                </Box>
              </Box>
              <Box width="fit-content" mr="15px" className="header_en_mypage">
                <Link href="/en/mypage/home?path=My%20Account">My Account</Link>
              </Box>

              <Button
                onClick={() => _handleLogout()}
                className="logout-btn  header_en_logout"
                width="fit-content"
              >
                Sign Out
              </Button>
            </Box>
          ) : isLogin === 0 ? (
            <Box width="fit-content" className="flex-between">
              <Box
                width="fit-content"
                className="top-bar_transfer_lang"
                mr="15px"
                onMouseEnter={() => setHeaderLangVisible(true)}
                onMouseLeave={() => setHeaderLangVisible(false)}
              >
                <Box>
                  <Box className="top-bar_box top-bar-en">
                    <i className="xi-globus" style={{ marginRight: "5px" }}></i>
                    EN
                  </Box>
                  {headerLangVisible && (
                    <ul>
                      <li
                        onClick={() => {
                          setHeaderLangVisible(false);
                        }}
                      >
                        <b>EN</b>
                        <em></em>
                        <span>English</span>
                        <FontAwesomeIcon icon={faCheck} />
                      </li>
                      <li onClick={transferLanguage}>
                        <b>KO</b>
                        <em></em>
                        <span>한국어</span>
                        <FontAwesomeIcon icon={faCheck} />
                      </li>
                    </ul>
                  )}
                </Box>
              </Box>
              <Box width="fit-content" mr="15px" className="header_en_login">
                <Link href="/en/auth/login">Sign In</Link>
              </Box>
              <Box className="top-boar__register flex-center header_en_join">
                <Link href="/en/auth/register">Sign Up</Link>
              </Box>
            </Box>
          ) : (
            ""
          )}
        </Box>
        <Box className="search-bar header_en_main">
          <Box className="search-gnb">
            <Box className="header_en_logo">
              <Box className={"header-logo cursor"}>
                <Link href="/en" className="panda-logo">
                  <img
                    src="/images/en/panda_market_05.png"
                    alt="pandaparts logo"
                    width="150px"
                    height="auto"
                  />
                </Link>
              </Box>
            </Box>
            <Spacer width="30px" height="100%" float="left"></Spacer>
            <Square className="header_en_search">
              {/* 검색파트 시작 */}
              <div>
                <div className="search_category">
                  <div>
                    <input
                      className="search_category_input"
                      placeholder="Search by Part Number"
                      value={search}
                      onChange={saveKeyword}
                      onKeyPress={OnEnter}
                    />
                    <button onClick={searchKeyword}>
                      <i className="xi-search"></i>
                    </button>
                  </div>
                </div>
              </div>
            </Square>
            {/* 검색파트 끝 */}
            <Spacer width="20px" height="100%" float="left"></Spacer>
            <Box width="265px" float="left" className="header_en_menu">
              <Flex width="100%">
                <Flex
                  bg=""
                  height="fit-content"
                  flex="1"
                  justifyContent="flex-end"
                >
                  {" "}
                  <Box
                    bg=""
                    width="fit-content"
                    height="100%"
                    pt="15px"
                    className="cursor"
                  >
                    <Link
                      href={
                        isLogin === 1
                          ? "/en/estimate/request?type=manual"
                          : "/en/auth/login?before=/en/estimate/request?type=manual"
                      }
                      passHref
                    >
                      <Box
                        bg=""
                        h="fit-content"
                        color="white"
                        className="header-btn header_btn_en"
                      >
                        <Box>
                          <img
                            src="/images/en/Create_RFQ.png"
                            alt="createRFQ"
                            width="35"
                            style={{
                              margin: "0 auto",
                            }}
                          ></img>
                          {/* <Badge
                            colorScheme="red"
                            padding={2}
                            borderRadius={30}
                            marginLeft={1}
                          >
                            {estimateCnt}
                          </Badge> */}
                        </Box>
                        <Box className="header_heading">
                          <Heading
                            as="h6"
                            size="sm"
                            color="#555"
                            fontSize="13px"
                          >
                            Create RFQ
                          </Heading>
                        </Box>
                      </Box>
                    </Link>
                  </Box>
                </Flex>
                <Flex
                  bg=""
                  height="fit-content"
                  flex="1"
                  justifyContent="flex-end"
                >
                  {" "}
                  <Box
                    bg=""
                    width="fit-content"
                    height="100%"
                    pt="15px"
                    className="cursor"
                  >
                    <Link
                      href={
                        isLogin === 1
                          ? "/en/estimate/lists"
                          : "/en/auth/login?before=/en/estimate/lists"
                      }
                      passHref
                    >
                      <Box
                        bg=""
                        h="fit-content"
                        color="white"
                        className="header-btn header_btn_en"
                      >
                        <Box>
                          {" "}
                          <img
                            src="/images/en/My_RFQ.png"
                            alt="견적내역"
                            width="32"
                            style={{
                              filter:
                                "invert(32%) sepia(0%) saturate(734%) hue-rotate(214deg) brightness(101%) contrast(93%)",
                            }}
                          ></img>
                          <Badge
                            colorScheme="red"
                            padding={2}
                            borderRadius={30}
                            marginLeft={1}
                            display="flex"
                            alignItems="center"
                          >
                            {estimateCnt}
                          </Badge>
                        </Box>
                        <Box className="header_heading">
                          <Heading
                            as="h6"
                            size="sm"
                            color="#555"
                            fontSize="13px"
                          >
                            My RFQ
                          </Heading>
                        </Box>
                      </Box>
                    </Link>
                  </Box>
                </Flex>
                <Flex
                  bg=""
                  height="fit-content"
                  flex="1"
                  justifyContent="flex-end"
                >
                  <Box
                    bg=""
                    width="fit-content"
                    height="100%"
                    pt="15px"
                    className="cursor"
                  >
                    <Link
                      href={
                        isLogin === 1
                          ? "/en/market/cart"
                          : "/en/auth/login?before=/en/market/cart"
                      }
                      passHref
                    >
                      <Box
                        className="header-btn header_btn_en"
                        bg=""
                        h="fit-content"
                        color="white"
                      >
                        <Box>
                          <img
                            src="/images/en/RFQ_Cart.png"
                            alt="견적바구니"
                            width="32"
                          ></img>
                          <Badge
                            colorScheme={cartBadge}
                            p="2"
                            borderRadius={20}
                            marginLeft={1}
                            display="flex"
                            alignItems="center"
                          >
                            {quoteCnt}
                          </Badge>
                        </Box>
                        <Box className="header_heading">
                          {" "}
                          <Heading
                            as="h6"
                            size="sm"
                            color="#555"
                            fontSize="13px"
                          >
                            RFQ Cart
                          </Heading>
                        </Box>
                      </Box>
                    </Link>
                  </Box>
                </Flex>
              </Flex>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
